module.exports = __webpack_public_path__ + "static/media/blocto_new.22d630cd.svg";